export const mapToOptions = (data) => {
  if (Array.isArray(data?.data) && data?.data?.length > 0) {
    return data?.data?.map((v) => ({
      id: v?._id,
      value: v?._id,
      label: v?.name,
    }));
  }
};

export const mapToAddressOption = (address) => {
  const country = {
    _id: address?.country?._id,
    value: address?.country?._id,
    label: address?.country?.name,
  };
  const ward = {
    _id: address?.ward?._id,
    value: address?.ward?._id,
    label: address?.ward?.name,
  };
  const district = {
    _id: address?.ward?.district?._id,
    value: address?.ward?.district?._id,
    label: address?.ward?.district?.name,
  };
  const province = {
    _id: address?.ward?.province?._id ?? address?.ward?.district?.province?._id,
    value: address?.ward?.province?._id ?? address?.ward?.district?.province?._id,
    label: address?.ward?.province?.name ?? address?.ward?.district?.province?.name,
  };
  return {
    country,
    ward,
    district,
    province,
  };
};

export const checkVietnam = (country) => {
  const value = String(country?.label || country?.name || "").toLowerCase();
  return value === "vietnam" || value === "việt nam";
};

export const getAddressIdsFromForm = (values) => {
  const isVietnam = checkVietnam(values?.country);
  if (isVietnam) {
    return {
      ward: values?.ward?.id,
      district: values?.district?.id,
      province: values?.province?.id,
    };
  }
  return {
    ward: null,
    province: null,
    district: null,
  };
};
